import React,{useEffect} from "react";
import './css/main.css';
import { InHomeUtils, CommonLQValidity } from '../../util/inhomeUtils';
import api from '../../service/apiService'
import {apiUrl} from '../../constants/apiUrl'
import * as action from '../../action/loopQual';
import { catchJSException } from '../../service/logService';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { store } from '../../index';
import Content from "./Content";
import { Provider } from "react-redux";

function ChannelLineUp(props) {

    ChannelLineUp.propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    useEffect(() => {
        createVisitID('','','','');
        const handleBeforeUnload = (event) => {
        //   event.preventDefault();
          window.sessionStorage.removeItem("searchedArray");
          window.sessionStorage.removeItem("PackageSelected");
          window.sessionStorage.removeItem("channelList");
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, []);


      async function createVisitID(changeLoc, MovesValue, frmExtSignIn, vendorInputParam) {
        let dt1 = new Date();
        try {
            let cookie_VisitId = window.localStorage.getItem("visit_id") || '';
            await CommonLQValidity(store.dispatch);
            let commonlqv = window.sessionStorage.getItem("commonLQ") || '';
            let commonLQV = commonlqv === 'y';
            if (props?.appState?.visitId === "" || cookie_VisitId === '' || changeLoc === 'Y' || (MovesValue && MovesValue?.mvFlow && this?.props?.appState?.flowType != "MV")) {
                const visitidUrl = apiUrl().createVisitId;
                console.log("visitidUrl",visitidUrl);
                const response = await api(visitidUrl, 'GET', '')
                console.log("response",response);
                if (InHomeUtils.isNotEmpty(response) && InHomeUtils.isNotEmpty(response.visit_id) && InHomeUtils.isNotEmpty(response.visitor_id)) {
                    window.localStorage.setItem('visit_id', response.visit_id);
                    window.localStorage.setItem('visitor_id', response.visitor_id);
                    let expTime = response.expirationTime;
                    if (!expTime && window.location.host.indexOf('localhost') !== -1) {
                        expTime = Date.now() + 86400000 - ((((new Date().getHours()) * 60) + (new Date().getMinutes())) * 60000);
                    }
                    window.localStorage.setItem('expirationTime', expTime);
                    window.sessionStorage.setItem('visit_id', response.visit_id);
                }
                action.setCookie(props.cookies, response, store);
            }
        }
        catch (ex) {
            catchJSException('loopQual_Error', props?.appState?.visitId, 'createVisitID', ex);
        }
        return true;
    }

    useEffect(() => {
        const close = (e) => {
          if(e.keyCode === 27){
             let dlg=document.querySelector(".Modal-container");
             if(dlg?.classList.contains('is-active'))
             {
               dlg.classList.remove('is-active');
             }	    
          }
        }
        window.addEventListener('keydown', close)
        return () => window.removeEventListener('keydown', close)
    },[])
    
    function focusHandler(event)
    {
        let lastButton=document.querySelector(".searchListContainer")
        //let closeButton=document.querySelector("#close-button")
        let closeButton=document.querySelector(".Modal-close")
        var code = event.keyCode || event.which;
        if (code === 9) {
          if (lastButton == document.activeElement) {
            event.preventDefault();
            closeButton.focus();
          }
        }
    }
    return (
        <div className="padding-all-zero inherit-height m_lq-main full-page-lq">
            <div className="margin-bottom-zero  m_page-height">
                <div className="inherit-height page active">
                    <div className="inherit-height CA"></div>
                    <div className="Channel-Line-up" onKeyDown={(event)=>focusHandler(event)}>
                    {/* <Modal 
                        toggleButton={<Button> Show Modal </Button>}
                        surface="light"
                        className="channelLine"
                        fullScreenDialog={false}
                        disableAnimation={false}
                        disableOutsideClick={false}
                        width="100%"
                        opened={open}
                        customScroll={true}
                    > */}
                        <div>
                            <Provider store={store}>
                                <Content />
                            </Provider>
                        </div>
                    {/* </Modal> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withCookies(ChannelLineUp);